<template>
  <v-container fluid>
    <v-card>
      <v-row class="px-3">
        <v-col cols="3">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="formatPayrollPeriod"
                data-vv-name="payrollPeriod"
                data-vv-as="payroll period"
                label="Payroll Period"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
              />
            </template>
            <v-date-picker
              ref="picker"
              v-model="payrollPeriod"
              type="month"
              scrollable
              @change="showPayrollCycle(payrollPeriod)"
              @click:month="menu = false"
            />
          </v-menu>
        </v-col>

        <v-spacer />

        <v-col
          v-if="!loading && payrollPeriod && !existingPayrollPeriod && $hasPermissionTo(['create payroll transactions'])"
          class="ma-auto"
          cols="2"
        >
          <payroll-payroll-period-dialog-create
            :payroll-period="payrollPeriod"
            @created="showPayrollCycle(payrollPeriod)"
          />
        </v-col>

        <v-col
          v-if="!loading && existingPayrollPeriod && isComputed && !(existingPayrollPeriod || {}).closed_on && $hasPermissionTo(['create payroll transactions'])"
          class="ma-auto"
          cols="2"
        >
          <close-payroll-period-confirmation
            :payroll-period-data="closePayrollPeriodData"
            @closed="closeDialog(), showPayrollCycle(payrollPeriod)"
          />
        </v-col>
      </v-row>
    </v-card>

    <payroll-payroll-cycle-container-view
      v-show="!showComputation"
      ref="payrollCycleContainer"
      :payroll-period="loadedPayrollPeriod"
      @created="viewComputation"
      @payrollComputed="showClosePayrollPeriodButton(true)"
      @payrollReverted="showClosePayrollPeriodButton(false)"
    />

    <payroll-payroll-cycle-computation-container-view
      v-show="showComputation"
      ref="computationContainerView"
      :payroll-period="existingPayrollPeriod || {}"
    >
      <template v-slot:navigation>
        <v-breadcrumbs 
          :items="navItems" 
          divider="/"
          class="py-0"
          large
        >
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              :disabled="item.disabled"
              @click="showComputation = false"
            >
              <span :class="{'cursor-pointer color-primary': !item.disabled}">{{ item.text }} </span>
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </template>
    </payroll-payroll-cycle-computation-container-view>
  </v-container>
</template>

<script>
  export default {
    components: {
      ClosePayrollPeriodConfirmation: () => import('@/components/hris/payroll/payroll-period/DialogClosePayrollPeriodConfirmation'),
      PayrollPayrollPeriodDialogCreate: () => import('@/components/hris/payroll/payroll-period/DialogCreate'),
      PayrollPayrollCycleContainerView: () => import('@/components/hris/payroll/payroll-cycle/ContainerView'),
      PayrollPayrollCycleComputationContainerView: () => import('@/components/hris/payroll/payroll-cycle/computation/ContainerView'),
    },
    data () {
      return {
        showComputation: false,
        dialog: null,
        navItems: [
          {
            text: 'Overview',
            disabled: false,
          },
          {
            text: 'Computation',
            disabled: true,
          },
        ],
        payrollPeriod: null,
        loadedPayrollPeriod: null,
        menu: false,
        existingPayrollPeriod: null,
        closePayrollPeriodData: null,
        payrollCycleEmployees: null,
        loading: false,
        isComputed: false,
      }
    },
    metaInfo () {
      return {
        title: 'Payroll Transaction',
      }
    },
    computed: {
      formatPayrollPeriod () {
        return this.payrollPeriod ? this.$moment(this.payrollPeriod + '-01').format('MMM YYYY') : ''
      },
    },
    methods: {
      showClosePayrollPeriodButton (status) {
        this.isComputed = status
      }, 
      closeDialog () {
        this.dialog = false
      },        
      loadPayrollCycles (object) {
        this.existingPayrollPeriod.payroll_cycle_transactions.forEach(transaction => {
          if (transaction.payroll_cycle_id === 1) {
            this.$refs.payrollCycleContainer.loadPayrollCycle(object.id, transaction)
          }
        })

        this.loadedPayrollPeriod = object
        this.closePayrollPeriodData = {
          payrollPeriod: this.payrollPeriod,
          payrollCycleEmployees: this.payrollCycleEmployees,
        }     
      },
      showPayrollCycle (payrollPeriod) {
        this.loading = true
        this.existingPayrollPeriod = null
        this.payrollCycleEmployees = null

        this.$api.payrollPeriods().show(payrollPeriod + '-01', '?close=false')
          .then(res => {
            this.existingPayrollPeriod = res.data
            this.existingPayrollPeriod.payroll_cycle_transactions.map(data => {
              this.payrollCycleEmployees = data.payroll_cycle_employees
            })            

            this.isComputed = this.existingPayrollPeriod.payroll_cycle_transactions.some(payrollCycleTransaction => payrollCycleTransaction['status'] === 'COMPUTED')

            this.loadPayrollCycles(this.existingPayrollPeriod)
            this.$refs.computationContainerView.loadPayrollCycleComputationSummary(this.existingPayrollPeriod.payroll_cycle_transactions[0].id)
          }).catch((e) => {
            if (e.response.status === 404) {
              this.$refs.payrollCycleContainer.clearPayrollCycles()
              this.$refs.computationContainerView.clearComputationSummary()

              this.showComputation = false
              console.clear()
            }
          }).then(() => {
            this.loading = false
          }) 
      },
      viewComputation (val) {
        if (val) {
          this.showComputation = true

          this.$refs.computationContainerView.loadPayrollCycleComputationSummary(val.id)
        }
      },
    },
  }
</script>

<style scoped>
.cursor-pointer{
  cursor: pointer;
} 
.color-primary{
  color:#9c27B0;
}
</style>
